import { render, staticRenderFns } from "./procurementReportTable.vue?vue&type=template&id=25feb80e"
import script from "./procurementReportTable.vue?vue&type=script&lang=js"
export * from "./procurementReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports